import { render, staticRenderFns } from "./DetalhesRepertorio.vue?vue&type=template&id=82eea0f0&scoped=true&"
import script from "./DetalhesRepertorio.vue?vue&type=script&lang=js&"
export * from "./DetalhesRepertorio.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesRepertorio.vue?vue&type=style&index=0&id=82eea0f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82eea0f0",
  null
  
)

export default component.exports